import { OnChanges, SimpleChanges, AfterViewInit, Renderer2, ElementRef, QueryList, ViewChild } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ClientSettings, CustomerField, CustomerInfo, CustomerType } from '../../models/contracts/Turbo.Data.Contracts';
import { SettingsService } from '../../services/settings.service'
import { ComponentBase } from '../component.base';



@Component({
  selector: 'customer-form-component',
  templateUrl: './customer-form.html',
  styleUrls: ['./customer-form.css']
})
export class CustomerFormComponent extends ComponentBase implements OnInit, OnChanges {
  @Input() public customer: CustomerInfo;
  @Input() private hideFields: string[] = [];
  @Input() private showFields: string[] = [];
  @Input() public clientSettingsForm: ClientSettings;

  @Output() public valueChanged = new EventEmitter<{ fieldId: string, value: string, isValid: boolean }>();

  public form: UntypedFormGroup;
  public formSettings: CustomerField[];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private settings: SettingsService,
    private renderer: Renderer2) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.formBuilder = new UntypedFormBuilder();
    this.form = new UntypedFormGroup(this.formBuilder.group({}).controls, { updateOn: 'blur' });

    // Load settings
    this.formSettings = await this.configureForm(this.settings.clientSettings, this.customer)

    //Need a otpion that if the booking isn't new, we need to fetch the Bookings locations setting and use their CustomercontextDef instead.'
    //Do we send the Booking Info aswell as the Customer Info to this form?
    //Or do we add Context to the CustomerInfo Object?
    

    // Make sure all CopyFrom fields are honored
    this.copyValuesFromCustomer(this.formSettings, this.customer);
    this.processCopyFrom(false);
  }


  async ngOnChanges(changes: SimpleChanges) {
    this.processCopyFrom(false);
    if (changes.customer) {
      // Remove existing controls
      for (var x in this.form.controls)
        this.form.removeControl(x);

      // Create new ones

      this.formSettings = await this.configureForm(this.clientSettingsForm.CustomerSettings ? this.clientSettingsForm : this.settings.clientSettings, this.customer)
      this.copyValuesFromCustomer(this.formSettings, this.customer);
    }
  }

  public update() {
    this.copyValuesFromCustomer(this.formSettings, this.customer);
  }

  public async customerTypeChanged() {
    this.formSettings = await this.configureForm(this.settings.clientSettings, this.customer)
  }


  public async modelChange(fieldId: string, value: string, recursive: boolean = false, valid: boolean = false) {
    if (this.customer.Fields[fieldId] == value) return;

    // Save the value
    this.customer[fieldId] = value;
    this.customer.Fields[fieldId] = value;

    if (!valid) valid = this.formSettings.find(x => x.FieldId == fieldId).IsValid;

    // Makre sure all fields are consistent
    if (!recursive) this.processCopyFrom(valid);


    this.valueChanged.emit({ fieldId: fieldId, value: value, isValid: valid });
  }


  private configureForm(settings: ClientSettings, customer: CustomerInfo): CustomerField[] {
    if (!settings.CustomerSettings) return null;


    // Copy the metadata objects
    let config = [];
    settings.CustomerSettings.Fields.filter(x => (x.ValidFor & this.customer.Type) == this.customer.Type).forEach(x => config.push({ ...x }));

    // Hide/Show fields
    if (this.hideFields.length > 0)
      config.map(x => x.Visible = x.Visible && !this.hideFields.includes(x.FieldId));
    else if (this.showFields.length > 0)
      config.map(x => x.Visible = x.Visible && this.showFields.includes(x.FieldId));

    this.copyValuesFromCustomer(config, customer);

    return config;
  }

  // Makes sure all fields that should get their value from another form gets updated
  private processCopyFrom(valid: boolean): void {
    if (!this.formSettings) return;

    this.formSettings
      .filter(x => x.CopyFrom != null)
      .forEach(x => {
        var source = this.formSettings.find(y => y.FieldId == x.CopyFrom);
        if (source && this.customer.Fields[x.CopyFrom] != this.customer.Fields[x.FieldId]) {
          this.modelChange(x.FieldId, this.customer.Fields[x.CopyFrom], true, valid);
        }
      });
  }

  private copyValuesFromCustomer(settings: CustomerField[], customer: CustomerInfo) {
    if (customer && settings) {
      for (var key in customer.Fields) {
        var field = settings.find(x => x.FieldId == key);
        if (field) field.Value = customer.Fields[key];
      }
    }
  }

  // Validate the form and return the result
  public validate(): boolean {
    this.form.markAllAsTouched();
    this.form.markAsDirty();
    this.form.updateValueAndValidity();
    return this.form.valid;
  }
  // Changes to the next field when pressing enter.
  // Nothing is happening if we get to the last field. To do.
  public handleEnterKey(event: any) {
    var currentField = event.target.closest("t4-text-field") as HTMLElement;
    var nextField = currentField.nextElementSibling?.getElementsByTagName('input')[0];
    if (nextField == null) return;
    nextField.focus();
    
  }
}
